import { TILE_SIZES } from '@mixtiles/web-backend-shared'

export type QuestionProps = {
  translateKey: string
  translateParams?: Record<string, string>
}

const COMMON_QUESTIONS: QuestionProps[] = [
  {
    translateKey: 'shipping-time',
  },
  {
    translateKey: 'move-tiles',
  },
  {
    translateKey: 'walls',
  },
  {
    translateKey: 'shipping-location',
  },
]

export const TILE_FAQS: QuestionProps[] = [
  {
    translateKey: 'frames',
    translateParams: {
      v1: TILE_SIZES.SQUARE_8X8,
      v2: TILE_SIZES.RECTANGLE_27X36,
      v3: TILE_SIZES.RECTANGLE_22X44,
    },
  },
  ...COMMON_QUESTIONS,
]

export const ART_FAQS: QuestionProps[] = [
  {
    translateKey: 'frames-art',
    translateParams: {
      v1: TILE_SIZES.RECTANGLE_8X11,
      v2: TILE_SIZES.RECTANGLE_22X44,
    },
  },
  ...COMMON_QUESTIONS,
]
